import { VendorGetOneAdapter } from '../../../../adapter';

export default async function VendorGetOneUseCase(event) {
    const { id } = event;

    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/vendor/get-one';

    const payload = {
        data: {
            vendorData: {
                id: id,
            },
            signature: ''
        }
    };

    const result = await VendorGetOneAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
